import React, { useState, useEffect } from "react";
import "./styles.css";

// 化学物质数据 - 从表格中提取
const chemicalData = [
  { name: "氢气", formula: "H2" },
  { name: "氯化钠", formula: "NaCl" },
  { name: "氧化铁", formula: "Fe2O3" },
  { name: "硫酸", formula: "H2SO4" },
  { name: "碳酸钠", formula: "Na2CO3" },
  { name: "氧化铝", formula: "Al2O3" },
  { name: "氧化汞", formula: "HgO" },
  { name: "氧化钙", formula: "CaO" },
  { name: "硫酸钾", formula: "K2SO4" },
  { name: "硫酸钠", formula: "Na2SO4" },
  { name: "硫酸铵", formula: "(NH4)2SO4" },
  { name: "硫酸亚铁", formula: "FeSO4" },
  { name: "硫酸铜", formula: "CuSO4" },
  { name: "硫酸镁", formula: "MgSO4" },
  { name: "硫酸钙", formula: "CaSO4" },
  { name: "硫酸锌", formula: "ZnSO4" },
  { name: "硫酸铁", formula: "Fe2(SO4)3" },
  { name: "硫酸铝", formula: "Al2(SO4)3" },
  { name: "亚硫酸钠", formula: "Na2SO3" },
  { name: "亚硫酸钡", formula: "BaSO3" },
  { name: "氯化钾", formula: "KCl" },
  { name: "氯化钙", formula: "CaCl2" },
  { name: "氯化镁", formula: "MgCl2" },
  { name: "氯化铝", formula: "AlCl3" },
  { name: "氯化铁", formula: "FeCl3" },
  { name: "氯化锌", formula: "ZnCl2" },
  { name: "氯化铵", formula: "NH4Cl" },
  { name: "氯化铜", formula: "CuCl2" },
  { name: "氯化钡", formula: "BaCl2" },
  { name: "氯化银", formula: "AgCl" },
  { name: "碳酸钾", formula: "K2CO3" },
  { name: "碳酸钡", formula: "BaCO3" },
  { name: "碳酸钙", formula: "CaCO3" },
  { name: "碳酸镁", formula: "MgCO3" },
  { name: "碳酸铁", formula: "FeCO3" },
  { name: "碳酸锌", formula: "ZnCO3" },
  { name: "碳酸银", formula: "Ag2CO3" },
  { name: "硝酸钠", formula: "NaNO3" },
  { name: "硝酸钾", formula: "KNO3" },
  { name: "硝酸钙", formula: "Ca(NO3)2" },
  { name: "硝酸镁", formula: "Mg(NO3)2" },
  { name: "硝酸铁", formula: "Fe(NO3)3" },
  { name: "硝酸银", formula: "AgNO3" },
  { name: "硝酸锌", formula: "Zn(NO3)2" },
  { name: "硝酸铜", formula: "Cu(NO3)2" },
  { name: "硝酸钡", formula: "Ba(NO3)2" },
  { name: "氢氧化钠", formula: "NaOH" },
  { name: "氢氧化钾", formula: "KOH" },
  { name: "氢氧化钙", formula: "Ca(OH)2" },
  { name: "氢氧化镁", formula: "Mg(OH)2" },
  { name: "氢氧化铁", formula: "Fe(OH)3" },
  { name: "氢氧化铝", formula: "Al(OH)3" },
  { name: "氢氧化铜", formula: "Cu(OH)2" },
  { name: "氢氧化钡", formula: "Ba(OH)2" },
  { name: "水", formula: "H2O" },
  { name: "氨气", formula: "NH3" },
  { name: "一氧化碳", formula: "CO" },
  { name: "二氧化碳", formula: "CO2" },
  { name: "二氧化硫", formula: "SO2" },
  { name: "三氧化硫", formula: "SO3" },
  { name: "五氧化二磷", formula: "P2O5" },
  { name: "氧化锰", formula: "MnO2" },
  { name: "氧化钠", formula: "Na2O" },
  { name: "氧化钾", formula: "K2O" },
  { name: "氧化镁", formula: "MgO" },
  { name: "氧化锌", formula: "ZnO" },
  { name: "氧化铜", formula: "CuO" },
  { name: "氧化钡", formula: "BaO" },
];

// 常用元素符号 - 按先非金属后金属排列
const elements = [
  // 非金属元素
  "H",
  "C",
  "N",
  "O",
  "S",
  "P",
  "Cl",
  // 金属元素
  "Na",
  "K",
  "Ca",
  "Mg",
  "Al",
  "Fe",
  "Cu",
  "Zn",
  "Ag",
  "Hg",
  "Ba",
  "Mn",
];

// 数字和符号
const numbers = ["1", "2", "3", "4", "5", "6", "7", "8", "9"];
const symbols = ["(", ")"];

// 元素汉字名称映射
const elementNames = {
  H: "氢",
  C: "碳",
  N: "氮",
  O: "氧",
  Na: "钠",
  Cl: "氯",
  Fe: "铁",
  S: "硫",
  Ca: "钙",
  Mg: "镁",
  Al: "铝",
  K: "钾",
  P: "磷",
  Mn: "锰",
  Ba: "钡",
  Cu: "铜",
  Zn: "锌",
  Ag: "银",
  Hg: "汞",
};

// 常用汉字 - 增加更多字符
const commonWords = [
  "化",
  "酸",
  "碱",
  "盐",
  "气",
  "水",
  "硝",
  "铵",
  "亚",
  "氨",
];

// 数字汉字 - 增加更多数字
const numberWords = [
  "一",
  "二",
  "三",
  "四",
  "五",
  "六",
  "七",
  "八",
  "九",
  "十",
];

// 修正的格式化化学式显示函数（除了开头数字外，其他数字都下标）
const formatFormula = (formula) => {
  // 首先处理不在开头的数字为下标
  return formula
    .replace(/([A-Z][a-z]?)(\d+)/g, "$1<sub>$2</sub>")
    .replace(/(\))(\d+)/g, "$1<sub>$2</sub>");
};

function ChemicalQuizApp() {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [userAnswer, setUserAnswer] = useState("");
  const [score, setScore] = useState(0);
  const [totalAnswered, setTotalAnswered] = useState(0); // 总答题数（不包括跳过的）
  const [showResult, setShowResult] = useState(false);
  const [feedback, setFeedback] = useState("");
  const [shuffledQuestions, setShuffledQuestions] = useState([]);
  const [gameFinished, setGameFinished] = useState(false);
  const [gameMode, setGameMode] = useState("formula"); // 'formula' 或 'name'
  const [showAnswer, setShowAnswer] = useState(false);
  const [skippedQuestions, setSkippedQuestions] = useState(new Set()); // 跳过的题目

  useEffect(() => {
    const shuffled = [...chemicalData].sort(() => Math.random() - 0.5);
    setShuffledQuestions(shuffled);
  }, []);

  const addToAnswer = (symbol) => {
    setUserAnswer(userAnswer + symbol);
  };

  const clearAnswer = () => {
    setUserAnswer("");
  };

  const deleteLastChar = () => {
    setUserAnswer(userAnswer.slice(0, -1));
  };

  const handleInputChange = (e) => {
    setUserAnswer(e.target.value);
  };

  const submitAnswer = () => {
    const currentChemical = shuffledQuestions[currentQuestion];
    const correctAnswer =
      gameMode === "formula" ? currentChemical.formula : currentChemical.name;
    const isCorrect = userAnswer === correctAnswer;

    if (isCorrect) {
      setScore(score + 1);
      setFeedback("✅ 答对了！");
    } else {
      setFeedback(`❌ 答错了！正确答案是：${correctAnswer}`);
    }

    setTotalAnswered(totalAnswered + 1);
    setShowResult(true);
  };

  const handleShowAnswer = () => {
    const currentChemical = shuffledQuestions[currentQuestion];
    const correctAnswer =
      gameMode === "formula" ? currentChemical.formula : currentChemical.name;
    setUserAnswer(correctAnswer);
    setShowAnswer(true);
    setSkippedQuestions((prev) => new Set(prev).add(currentQuestion));
    setFeedback(`💡 正确答案：${correctAnswer}`);
    setShowResult(true);
  };

  const nextQuestion = () => {
    if (currentQuestion < shuffledQuestions.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
      setUserAnswer("");
      setShowResult(false);
      setFeedback("");
      setShowAnswer(false);
    } else {
      setGameFinished(true);
    }
  };

  const restartGame = () => {
    setCurrentQuestion(0);
    setUserAnswer("");
    setScore(0);
    setTotalAnswered(0);
    setShowResult(false);
    setFeedback("");
    setGameFinished(false);
    setShowAnswer(false);
    setSkippedQuestions(new Set());
    const shuffled = [...chemicalData].sort(() => Math.random() - 0.5);
    setShuffledQuestions(shuffled);
  };

  const switchMode = (mode) => {
    setGameMode(mode);
    setCurrentQuestion(0);
    setUserAnswer("");
    setScore(0);
    setTotalAnswered(0);
    setShowResult(false);
    setFeedback("");
    setGameFinished(false);
    setShowAnswer(false);
    setSkippedQuestions(new Set());
    const shuffled = [...chemicalData].sort(() => Math.random() - 0.5);
    setShuffledQuestions(shuffled);
  };

  if (shuffledQuestions.length === 0) {
    return <div className="App loading">加载中...</div>;
  }

  if (gameFinished) {
    const accuracyRate =
      totalAnswered > 0 ? ((score / totalAnswered) * 100).toFixed(1) : "0.0";
    return (
      <div className="App">
        <div className="game-finished">
          <div className="finish-icon">🎉</div>
          <h1>测验完成</h1>
          <div className="final-score">
            <div className="score-item">
              <span className="label">答对题数</span>
              <span className="score-number">{score}</span>
              <span className="total">/ {totalAnswered}</span>
            </div>
            <div className="score-item">
              <span className="label">正确率</span>
              <span className="score-percentage">{accuracyRate}%</span>
            </div>
          </div>
          <div className="finish-buttons">
            <button className="restart-btn" onClick={restartGame}>
              再玩一次
            </button>
            <button
              className="mode-switch-btn"
              onClick={() =>
                switchMode(gameMode === "formula" ? "name" : "formula")
              }
            >
              切换模式
            </button>
          </div>
        </div>
      </div>
    );
  }

  const currentChemical = shuffledQuestions[currentQuestion];
  const progress = (
    ((currentQuestion + 1) / shuffledQuestions.length) *
    100
  ).toFixed(1);
  const accuracyRate =
    totalAnswered > 0 ? ((score / totalAnswered) * 100).toFixed(1) : "0.0";

  return (
    <div className="App">
      {/* 超紧凑的header - 标题、模式选择和统计都在一行 */}
      <header className="header">
        <div className="header-content">
          <h1>🧪 化学式测验</h1>

          <div className="mode-switcher">
            <button
              className={`mode-btn ${gameMode === "formula" ? "active" : ""}`}
              onClick={() => switchMode("formula")}
            >
              写化学式
            </button>
            <button
              className={`mode-btn ${gameMode === "name" ? "active" : ""}`}
              onClick={() => switchMode("name")}
            >
              写名称
            </button>
          </div>

          <div className="stats-info">
            <div className="progress-container">
              <div className="progress-bar">
                <div
                  className="progress-fill"
                  style={{ width: `${progress}%` }}
                ></div>
              </div>
              <span className="progress-text">
                {currentQuestion + 1}/{shuffledQuestions.length}
              </span>
            </div>
            <div className="accuracy-display">
              <span className="accuracy-label">正确率</span>
              <span className="accuracy-rate">{accuracyRate}%</span>
            </div>
          </div>
        </div>
      </header>

      <main className="main-content">
        <div className="question-card">
          <div className="question-label">
            {gameMode === "formula"
              ? "请写出以下物质的化学式"
              : "请写出以下化学式的中文名称"}
          </div>
          <div className="chemical-display">
            {gameMode === "formula" ? (
              currentChemical.name
            ) : (
              <span
                dangerouslySetInnerHTML={{
                  __html: formatFormula(currentChemical.formula),
                }}
              />
            )}
          </div>
        </div>

        <div className="answer-card">
          <label className="answer-label">您的答案</label>

          {/* 在汉字模式下显示输入框 */}
          {gameMode === "name" && (
            <input
              type="text"
              className="answer-input"
              value={userAnswer}
              onChange={handleInputChange}
              placeholder="在此直接输入答案，或使用下方按钮..."
              disabled={showResult}
            />
          )}

          <div className="answer-display">
            {gameMode === "formula" ? (
              <span
                dangerouslySetInnerHTML={{
                  __html: userAnswer
                    ? formatFormula(userAnswer)
                    : "点击下方按钮构建化学式...",
                }}
              />
            ) : (
              <span>{userAnswer || "点击下方按钮构建中文名称..."}</span>
            )}
          </div>

          <div className="button-row">
            <div className="control-buttons">
              <button
                className="control-btn delete"
                onClick={deleteLastChar}
                disabled={!userAnswer || showResult}
              >
                删除
              </button>
              <button
                className="control-btn clear"
                onClick={clearAnswer}
                disabled={!userAnswer || showResult}
              >
                清空
              </button>
              <button
                className="control-btn show-answer"
                onClick={handleShowAnswer}
                disabled={showResult}
              >
                显示答案
              </button>
            </div>

            <div className="action-buttons">
              {!showResult ? (
                <button
                  className="submit-btn"
                  onClick={submitAnswer}
                  disabled={!userAnswer.trim()}
                >
                  提交答案
                </button>
              ) : (
                <button className="next-btn" onClick={nextQuestion}>
                  {currentQuestion < shuffledQuestions.length - 1
                    ? "下一题"
                    : "查看结果"}
                </button>
              )}
            </div>
          </div>

          {showResult && (
            <div
              className={`feedback ${
                feedback.includes("✅")
                  ? "correct"
                  : feedback.includes("💡")
                  ? "show-answer"
                  : "incorrect"
              }`}
            >
              {gameMode === "formula" ? (
                <span
                  dangerouslySetInnerHTML={{
                    __html: feedback.replace(
                      /：(.+)$/,
                      (match, formula) => `：${formatFormula(formula)}`
                    ),
                  }}
                />
              ) : (
                <span>{feedback}</span>
              )}
            </div>
          )}
        </div>

        <div className="input-panel">
          {gameMode === "formula" ? (
            // 原有的化学式输入面板
            <>
              <div className="panel-section">
                <h3>元素符号</h3>
                <div className="elements-grid">
                  {elements.map((element) => (
                    <button
                      key={element}
                      className="element-btn"
                      onClick={() => addToAnswer(element)}
                      disabled={showResult}
                    >
                      {element}
                    </button>
                  ))}
                </div>
              </div>

              <div className="panel-section">
                <h3>数字和符号</h3>
                <div className="numbers-grid">
                  {numbers.map((num) => (
                    <button
                      key={num}
                      className="number-btn"
                      onClick={() => addToAnswer(num)}
                      disabled={showResult}
                    >
                      {num}
                    </button>
                  ))}
                  {symbols.map((symbol) => (
                    <button
                      key={symbol}
                      className="symbol-btn"
                      onClick={() => addToAnswer(symbol)}
                      disabled={showResult}
                    >
                      {symbol}
                    </button>
                  ))}
                </div>
              </div>
            </>
          ) : (
            // 新的中文名称输入面板
            <>
              <div className="panel-section">
                <h3>元素名称</h3>
                <div className="chinese-grid">
                  {Object.values(elementNames).map((name) => (
                    <button
                      key={name}
                      className="chinese-btn element-name"
                      onClick={() => addToAnswer(name)}
                      disabled={showResult}
                    >
                      {name}
                    </button>
                  ))}
                </div>
              </div>

              <div className="panel-section">
                <h3>常用字</h3>
                <div className="chinese-grid">
                  {commonWords.map((word) => (
                    <button
                      key={word}
                      className="chinese-btn common-word"
                      onClick={() => addToAnswer(word)}
                      disabled={showResult}
                    >
                      {word}
                    </button>
                  ))}
                </div>
              </div>

              <div className="panel-section">
                <h3>数字汉字</h3>
                <div className="chinese-grid">
                  {numberWords.map((num) => (
                    <button
                      key={num}
                      className="chinese-btn number-word"
                      onClick={() => addToAnswer(num)}
                      disabled={showResult}
                    >
                      {num}
                    </button>
                  ))}
                </div>
              </div>
            </>
          )}
        </div>
      </main>
    </div>
  );
}

export default ChemicalQuizApp;
